import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Invoices_ds_get_billing_accessorial_charges_templates_lines_rates_gridService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { template_line_id: number }): 
  Promise<{ result: { Id?: number, BillingAccessorialChargeTemplateLineId?: number, BillingCodeId?: number, BillingContractLineId?: number, LookupCode?: string, MinimumCharge?: number, PerAmount?: number, RangeEnd?: number, RangeStart?: number, Rate?: number, TypeId?: number, BillingRateTypes?: { Id?: number, Name?: string } }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.template_line_id)) {
      $missingRequiredInParams.push('\'template_line_id\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getList($inParams: { template_line_id: number, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, BillingAccessorialChargeTemplateLineId?: number, BillingCodeId?: number, BillingContractLineId?: number, LookupCode?: string, MinimumCharge?: number, PerAmount?: number, RangeEnd?: number, RangeStart?: number, Rate?: number, TypeId?: number, BillingRateTypes?: { Id?: number, Name?: string } }[], totalCount: number }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.template_line_id)) {
      $missingRequiredInParams.push('\'template_line_id\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { template_line_id: number, $keys: number[] }): 
  Promise<{ result: { Id?: number, BillingAccessorialChargeTemplateLineId?: number, BillingCodeId?: number, BillingContractLineId?: number, LookupCode?: string, MinimumCharge?: number, PerAmount?: number, RangeEnd?: number, RangeStart?: number, Rate?: number, TypeId?: number, BillingRateTypes?: { Id?: number, Name?: string } }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.template_line_id)) {
      $missingRequiredInParams.push('\'template_line_id\'');
    }
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      template_line_id: number    }) {
        if(isNil($inParams.template_line_id)) {
          return true; 
        }
      return false;
    }
}
